// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const ChevronUpBigIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18 16a1 1 0 01-.71-.29L12 10.41l-5.29 5.3a1 1 0 01-1.42-1.42l6-6a1 1 0 011.42 0l6 6a1 1 0 010 1.42A1 1 0 0118 16z" fill="currentColor"/></svg>'} />;

ChevronUpBigIcon.displayName = 'ChevronUpBigIcon';

export default ChevronUpBigIcon;
